import { IImage } from '@utils/contentful/contentfulImage'
import { ContentfulNextJsImage } from '@components/common/ContentfulImage'

interface ITeam {
  title: string
  image: IImage
}

interface ITeams {
  teamList: ITeam[]
}

export function Teams({ teamList }: ITeams) {
  return (
    <div className="relative flex flex-wrap items-start max-w-full p-0 m-auto md:px-20 md:pb-10">
      {teamList?.map((item, index) => (
        <div
          key={index}
          className="w-full sm:w-1/2 lg:w-2/6 xl:w-3/12 xl:px-4 xl:mb-6"
        >
          <div className="relative flex items-end justify-center w-full md:min-h-[211px]">
            <ContentfulNextJsImage
              alt={item.image?.imageTitle}
              src={item.image?.imageUrl}
              width={180}
              height={210}
              objectFit="contain" // FIXME: No image optimized?
            />
          </div>
          <div className="w-[181px] text-center m-auto mt-5">
            <h5 className="mb-6 text-xl font-bold uppercase text-pitaya">
              {item?.title}
            </h5>
          </div>
        </div>
      ))}
    </div>
  )
}
